import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";

const ParagraphStyle = styled.p.attrs(
  ({ $color, $backgroundColor, $align, $fontSize }) => ({
    $color: $color || "",
    $backgroundColor: $backgroundColor || "",
    $fontSize: $fontSize || undefined,
    $align: $align || "",
  })
)`
  color: ${({ $color }) => $color};
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  font-size: ${({ $fontSize }) => $fontSize};
  text-align: ${({ $align }) => $align};
  ${({ $linkColor }) =>
    $linkColor &&
    css`
      a {
        color: ${$linkColor};
      }
    `}
`;

const Paragraph = ({
  color,
  backgroundColor,
  linkColor,
  content,
  style,
  align,
  fontSize,
  anchor,
  className,
  direction,
}) => {
  return (
    <ParagraphStyle
      {...(anchor && { id: anchor })}
      className={className}
      dir={direction || "auto"}
      style={style}
      $color={color}
      $backgroundColor={backgroundColor}
      $linkColor={linkColor}
      $fontSize={fontSize}
      $align={align}
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
};

Paragraph.propTypes = {
  color: PropTypes.string,
  backgroundColor: PropTypes.string,
  linkColor: PropTypes.string,
  content: PropTypes.string,
  style: PropTypes.object,
  anchor: PropTypes.string,
  className: PropTypes.string,
  fontSize: PropTypes.string,
  align: PropTypes.string,
  direction: PropTypes.string,
};

export default Paragraph;
